import { z } from 'zod'

// room-JWT + адрес сигналинга; живёт только в памяти вкладки (см. store.ts),
// не в localStorage/sessionStorage.
export const RoomAccessSchema = z.object({
  meetingId: z.string(),
  roomToken: z.string(),
  signaling: z.string(),
})

export type RoomAccess = z.infer<typeof RoomAccessSchema>

export const MeetingStateSchema = z.enum(['scheduled', 'active', 'ended', 'cancelled'])
export type MeetingState = z.infer<typeof MeetingStateSchema>

// Превью встречи по guest-токену — до формы имени: валидация ссылки и честный
// экран для ended/cancelled/scheduled вместо generic-отказа на POST join.
export const GuestMeetingPreviewSchema = z.object({
  title: z.string(),
  state: MeetingStateSchema,
  scheduledAt: z.string().optional(),
})
export type GuestMeetingPreview = z.infer<typeof GuestMeetingPreviewSchema>

// Гость после входа по ссылке — запись в lobby (ожидает допуска).
export const GuestLobbyEntrySchema = z.object({
  meetingId: z.string(),
  participantId: z.string(),
  state: z.string(),
})
export type GuestLobbyEntry = z.infer<typeof GuestLobbyEntrySchema>

// Снимок lobby-статуса гостя: roomAccess непуст только при state='joined';
// meetingState отличает «встреча завершилась, пока вы ждали» от «вас не пустили».
// Итог входа сотрудника: joined несёт roomAccess, waiting — закрытый звонок,
// клиент повторяет тот же вызов, пока его не впустят.
export const EmployeeJoinSchema = z.object({
  participantId: z.string(),
  state: z.enum(['waiting', 'joined', 'left']),
  meetingState: MeetingStateSchema,
  roomAccess: RoomAccessSchema.optional(),
})
export type EmployeeJoin = z.infer<typeof EmployeeJoinSchema>

export const GuestLobbyStateSchema = z.object({
  state: z.enum(['waiting', 'joined', 'left']),
  meetingState: MeetingStateSchema,
  roomAccess: RoomAccessSchema.optional(),
})
export type GuestLobbyState = z.infer<typeof GuestLobbyStateSchema>

// Гостевой контекст, восстановленный из HttpOnly-cookie (ставится join'ом):
// refresh вкладки возвращает гостя в lobby/комнату, а не на SSO-логин.
export const GuestSessionSchema = z.object({
  token: z.string(),
  participantId: z.string(),
  meetingId: z.string(),
  guestName: z.string(),
  state: z.enum(['waiting', 'joined', 'left']),
  meetingState: MeetingStateSchema,
  roomAccess: RoomAccessSchema.optional(),
})
export type GuestSession = z.infer<typeof GuestSessionSchema>

// Итог восстановления: none — куки нет/протухла (гость ничего не терял);
// ended/cancelled — контекст был, но встреча завершилась/отменилась (честный
// статус вместо логина); active — живой контекст (waiting/joined).
export type GuestSessionResult =
  | { kind: 'none' }
  | { kind: 'ended' }
  | { kind: 'cancelled' }
  | { kind: 'active'; session: GuestSession }
